import { Sizes } from '../constants/size';
import type { IconProps } from '../types/icon-props';

export const WalletRegular = (props: IconProps) => {
  const { size = 'md', fill = 'var(--grey-1)', stroke = 'var(--grey-1)', ...rest } = props;

  return (
    <svg
      width={Sizes[size]}
      height={Sizes[size]}
      viewBox="0 0 12 12"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <g fill={fill}>
        <path d="M11.25 3h-3V.75C8.25.3 7.95 0 7.5 0H2.25C.975 0 0 .975 0 2.25v7.5C0 11.025.975 12 2.25 12h9c.45 0 .75-.3.75-.75v-7.5c0-.45-.3-.75-.75-.75zM1.5 2.25c0-.45.3-.75.75-.75h4.5V3H1.5v-.75zm9 8.25H2.25c-.45 0-.75-.3-.75-.75V4.5h9v6z" />
        <path d="M9.75 6.75h-1.5v1.5h1.5v-1.5z" />
      </g>
    </svg>
  );
};

WalletRegular.displayName = 'WalletRegular';
